import React, { memo } from 'react';
import styles from './secondOption.module.scss';
import { UsequestionsState } from '@/store/atoms/questionsState';

import { useInputValuesState } from '../../../../store/atoms/inputValuesState';

export const SecondOption = memo(({ options, type }) => {


  const { catList } = UsequestionsState();
  const { setInputValues,inputValues,currentNum,setCurrentNum } = useInputValuesState();

  console.log('currentNum', currentNum);
  console.log('catList', catList);



  // const typeSum = (type, value) => {
  //   switch (type.term_id) {
  //     case catList[0].term_id:
  //       setpartSum01(partSum01 + value);
  //       break;
  //     case catList[1].term_id:
  //       setpartSum02(partSum02 + value);
  //       break;
  //     case catList[2].term_id:
  //       setpartSum03(partSum03 + value);
  //       break;
  //     case catList[3].term_id:
  //       setpartSum04(partSum04 + value);
  //       break;
  //     case catList[4].term_id:
  //       setpartSum05(partSum05 + value);
  //       break;
  //   }
  //   if (currentNum >= 14) {
  //     navigate('/result');
  //   }
  // };

  const answerClick = (e) => {
    console.log('answerClickinputValues',inputValues[0])
    console.log('answerClickcurrentNum',currentNum)
    setInputValues(
        inputValues.map((inputValue, index) =>
          (index === currentNum ? { id: index, term_id:type.term_id, name:type.name ,num: Number(e.target.value) } : inputValue)
        )
    );
    setCurrentNum(currentNum + 1);
    console.log('aftersetCurrentNumcurrentNum',currentNum)
  };

  return (
    <>
      <ul className={styles.option}>
        <li className={styles.item}>
          <button className={styles.button} value='2' onClick={answerClick}>
            {options.answer1}
          </button>
        </li>
        <li className={styles.item}>
          <button className={styles.button} value='1' onClick={answerClick}>
            {options.answer2}
          </button>
        </li>
        {
          options.answer3 &&
            <li className={styles.item}>
              <button className={`${styles.button}`} value='0' onClick={answerClick}>
                {options.answer3}
              </button>
            </li>
        }
      </ul>
    </>
  );
});
